import { render, staticRenderFns } from "./SettingsVatShippings.vue?vue&type=template&id=6d1978f2&"
import script from "./SettingsVatShippings.vue?vue&type=script&lang=js&"
export * from "./SettingsVatShippings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports